import { IPropertyFilter } from './IPropertyFilter'

export type Ternary = 'true' | 'false' | 'empty'

export const isValidTernary = (value: Ternary): boolean => value !== 'empty'

export interface ITernaryFilter<T> extends IPropertyFilter<T> {
  type: 'ternary'
  value: Ternary
}

export const isTernaryFilter = <T>(
  filter: IPropertyFilter<T>,
): filter is ITernaryFilter<T> => filter.type === 'ternary'

export const normalizeTernaryFilter = <T>({
  propertyName,
  value,
}: ITernaryFilter<T>): string => {
  if (value === 'empty') return ''
  return `(${String(propertyName)} eq ${value})`
}
